<template>
    <el-dialog title="会议照片" :close-on-click-modal="false" :visible.sync="visible" width="800px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" :inline="true" label-width="100px"
            class="border-form">
            <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="会议编号" prop="fileName" class="item">
                        {{ dataForm.meetNumber }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;">
                <el-col :span="24">
                    <el-upload ref="uploadTempImg" class="upload-demo" action="action" style=""  :before-upload="beforeUploadSituation"
                        :http-request="uploadTempImg" multiple drag :show-file-list=false :auto-upload="true"
                        accept="image/jpeg,image/png,image/jpg">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-col>
                <el-col :span="24">
                    <div v-for="(photo, index) in dataForm.photoRecords" :key="'meet' + index"
                        v-if="dataForm.photoRecords != undefined && dataForm.photoRecords.length > 0"
                        :style="{ order: photo.sort }">
                        <el-col :span="12" class="photo_col">
                            <!-- 在col内部添加相对定位 -->
                            <div style="margin:20px 20px 20px 20px; position: relative; height: 100%;">
                                <!-- 删除按钮 - 完全在照片上方，不接触照片 -->
                                <div class="photo-delete-btn" @click="deletePhoto(index)" title="删除照片">
                                    <i class="el-icon-close"></i>
                                </div>

                                <!-- 照片区域 -->
                                <div style="margin-top: 30px;"><!-- 增加上边距，给按钮留出空间 -->
                                    <el-image style="height: 250px; width: 100%;" :src="photo.compressedPathUri"
                                        fit='contain'></el-image>
                                </div>

                                <!-- 照片描述输入框 -->
                                <div class="t-column-ellipsis">
                                    <el-input v-model="photo.photoContent" placeholder="照片描述"></el-input>
                                </div>
                            </div>
                        </el-col>
                    </div>
                </el-col>
            </el-row>
            <el-row class="formBtnGroup">
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="dataFormSubmit()">保存</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    data() {
        return {
            visible: false,
            dataForm: {
                workNo: $common.getItem("workNo"),
                meetId: '',
                photoRecords: []
            },
            dataRule: {
            }
        };
    },
    components: {

    },
    activated() {

    },
    mounted() {
    },
    methods: {
        init(meetId) {
            this.dataForm = {
                workNo: $common.getItem("workNo"),
                meetId: meetId,
                photoRecords: []
            };
            this.visible = true
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.meetId) {
                    this.$http({
                        url: this.$store.state.httpUrl + `/business/meetinfo/info/${this.dataForm.meetId}`,
                        method: 'get'
                    }).then(({ data }) => {
                        if (data && data.resultCode === 200) {
                            this.dataForm = data.body;
                        }
                    })
                }
            })
        },
        deletePhoto(index) {
            this.dataForm.photoRecords.splice(index, 1)
        },
        uploadTempImg(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadTempImg.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                },
            ).then(res => {
                res = res.data
                if (res.resultCode === 200) {
                    this.dataForm.photoRecords.push({
                        photoFilePath: res.body.fileSavePath,
                        photoFilePathUrl: res.body.fileUri,
                        photoContent: this.extractFileName(res.body.fileName),
                        compressedPath: res.body.compressedPath,
                        compressedPathUri: res.body.fileUri,
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},
        dataFormSubmit() {
            const _url = "/business/meetphotoinfo/updatePhoto";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData({
                    meetId: this.dataForm.meetId,
                    workNo: $common.getItem("workNo"),
                    photoRecords: this.dataForm.photoRecords
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            this.$parent.getDataList();
                        }
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        }
    }
};
</script>

<style scoped="scoped">
.item::v-deep .el-form-item__label {
    color: #00428E !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: #E1F1FF;
    white-space: nowrap !important;
    border-right: solid #dadada 1px;
}

.upload-demo /deep/ .el-upload-dragger {
    width: 740px !important;
    height: 80px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
    font-size: 30px;
    margin: 8px 1px;
    line-height: 20px;
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
    line-height: 5px;
}

.border-form .el-row.set_border {
    border-bottom: solid #dadada 1px;
    border-left: solid #dadada 1px;
    border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
    border-top: solid #dadada 1px;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.photo-delete-btn {
    position: absolute;
    top: -25px;
    /* 负值让按钮完全在容器顶部外面 */
    right: 0;
    width: 24px;
    height: 24px;
    background-color: #ffffff;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
    font-size: 14px;
}

.photo-delete-btn:hover {
    color: black;
    transform: scale(1.1);
}

.photo_col {
    border: 1px solid rgba(235, 238, 240, 1);
}
</style>
